<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pviii"></a><a class="page" id="pix"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/Marbury0008#ch01">Preface: Locating the Project</a></p>
<p class="tocfm"><a class="xref" href="#/Marbury0009#acknow">Acknowledgments</a></p>
<p class="toc"><a class="xref" href="#/Marbury0010#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/Marbury0011#ch02">1. Exodus: Israelite Deliverance and Antebellum Hope</a></p>
<p class="toc"><a class="xref" href="#/Marbury0012#ch03">2. Exodus in the Wilderness: Making Bitter Water Sweet</a></p>
<p class="toc"><a class="xref" href="#/Marbury0013#ch04">3. Exodus and Hurston: Toward a Humanist Critique of Black Religion in the Harlem Renaissance</a></p>
<p class="toc"><a class="xref" href="#/Marbury0014#ch05">4. Exodus in the Civil Rights Era: Returning the Struggle to the Black Church</a></p>
<p class="toc"><a class="xref" href="#/Marbury0015#ch06">5. Exodus at the Intersection of the Black Power Movement and the Black Church</a></p>
<p class="toc"><a class="xref" href="#/Marbury0016#ch07">Conclusion: Cloud, Fire, and Beyond</a></p>
<p class="tocbm"><a class="xref" href="#/Marbury0017#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/Marbury0018#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/Marbury0019#ch08">Index of Names</a></p>
<p class="tocbm"><a class="xref" href="#/Marbury0020#ch09">Index of Subjects</a></p>
<p class="tocbm"><a class="xref" href="#/Marbury0021#aubio">About the Author</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Marbury-0007.vue?4dcf306a